"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _AsyncTemplatesSettingsContainer = _interopRequireDefault(require("./containers/AsyncTemplatesSettingsContainer"));

var _AsyncGeneralSettingsContainer = _interopRequireDefault(require("./containers/AsyncGeneralSettingsContainer"));

var _ContentMembershipSettingsWrapper = _interopRequireDefault(require("./containers/ContentMembershipSettingsWrapper"));

var _BaseContentMembershipSettingsContainer = _interopRequireDefault(require("./containers/BaseContentMembershipSettingsContainer"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _tracking = require("settings-ui-app/utils/tracking");

var _default = _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.CONTENT_MEMBERSHIP,
  component: _BaseContentMembershipSettingsContainer.default
}, _react.default.createElement(_reactRouter.IndexRedirect, {
  to: _UrlPathParams.ALL_DOMAINS
}), _react.default.createElement(_reactRouter.Route, {
  path: ":allDomainsOrDomainId",
  component: _ContentMembershipSettingsWrapper.default
}, _react.default.createElement(_reactRouter.IndexRedirect, {
  to: _UrlPathParams.GENERAL
}), _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.GENERAL,
  component: _AsyncGeneralSettingsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_UrlPathParams.GENERAL)
}), _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.TEMPLATES,
  component: _AsyncTemplatesSettingsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_UrlPathParams.TEMPLATES)
})));

exports.default = _default;
module.exports = exports.default;